export enum HttpAuthenticationType {
  BASIC = 'Basic',
  BEARER = 'Bearer',
  DIGEST = 'Digest',
  HOBA = 'HOBA',
  MUTUAL = 'Mutual',
  NEGOTIATE = 'Negotiate',
  OAUTH = 'OAuth',
  SCRAM_SHA_1 = 'SCRAM-SHA-1',
  SCRAM_SHA_256 = 'SCRAM-SHA-256',
  VAPID = 'vapid'
}